// shows that arrays are the same -- can be moved to it's own Utils file in
// utils folder
class ArrayUtils {
    static compareArraysEqualSets(a1, a2) {
        let superSet = {};
        for (let i = 0; i < a1.length; i++) {
            const e = a1[i] + typeof a1[i];
            superSet[e] = 1;
        }

        for (let i = 0; i < a2.length; i++) {
            const e = a2[i] + typeof a2[i];
            if (!superSet[e]) {
                return false;
            }
            superSet[e] = 2;
        }

        for (let i in superSet) {
            if (superSet[i] === 1) {
                return false;
            }
        }

        return true;
    }

    static convertToISO(date) {
        var main = date.slice(0, 19);
        var extra = '-00:00'
        date = main + extra;
        return new Date(date).toISOString();
    }
}

export default ArrayUtils;
